'use client';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React, { useCallback, useEffect, useState } from 'react';

import HelpCircleIcon from '@/assets/icons/inbound/help-circle.svg';
import PercentIcon from '@/assets/icons/inbound/percent.svg';
import PosIcon from '@/assets/icons/inbound/pos.svg';
import StoneLogo from '@/assets/icons/stoneLogo/stone-logo.svg';
import { Choose } from '@/components/UtilitiesComponents';
import { useInbound } from '@/contexts/inbound';
import { attendanceStatusTitle } from '@/resources/inbound';
import { checkPathAccess } from '@/services/normalizedPath';
import { handlePhoneOnInboundSiteClick } from '@/utils/Analytics';

import styles from '../Inbound.module.css';
import InbondFooter from './footer';

const blackFridayOffer = process.env.IS_BLACK_FRIDAY == 'true';

const LayoutStone: React.FC<{ children?: React.ReactNode }> = ({
  children,
  ...props
}) => {
  const onPhoneClick = useCallback(() => {
    handlePhoneOnInboundSiteClick('/adquira/');
  }, []);

  const { hasPhoneChannelAvailable, attendanceStatus } = useInbound();

  const pathname = usePathname() as string;
  const [acquire, setAcquire] = useState(false);

  useEffect(() => {
    if (pathname) {
      setAcquire(checkPathAccess({ pathname, pathRestrictions: '/adquira' }));
    }
  }, [pathname]);

  return (
    <div className="overflow-auto w-full h-full bg-display-100" {...props}>
      <div className="flex mx-auto w-full md:max-w-max h-max">
        <div className={styles.formContainer}>{children}</div>
        <div className="hidden md:flex md:flex-col my-40 mr-40">
          <div className="flex flex-col my-auto">
            <div
              className={`flex lg:flex-row gap-8  px-40 lg:gap-40 ${
                attendanceStatus === 'scheduled'
                  ? 'flex-row gap-40'
                  : 'flex-col'
              }`}
            >
              <div className="flex lg:justify-center items-center cursor-pointer">
                <Link href="/" aria-label="Link para página inicial">
                  <StoneLogo
                    className=" w-[152px] h-40"
                    alt="Logo da Stone - redireciona para home"
                  />
                </Link>
              </div>
              <div>
                <p className="paragraph-16">Atendimento</p>
                <p
                  className={`paragraph-20 font-bold ${
                    attendanceStatus === 'available'
                      ? 'text-stone-500'
                      : 'text-display-900'
                  }`}
                >
                  {attendanceStatusTitle[attendanceStatus]}
                </p>
              </div>
              {hasPhoneChannelAvailable && (
                <div>
                  <p className="paragraph-16">Adquira pelo telefone</p>
                  <a
                    href="tel:30049681"
                    onClick={onPhoneClick}
                    className="font-bold paragraph-20"
                  >
                    3004 9681
                  </a>
                </div>
              )}
            </div>

            <div className={styles.imageContainer}>
              <Choose>
                <Choose.When condition={acquire && blackFridayOffer}>
                  <div className={`hidden lg:flex w-full`}>
                    <Image
                      width={672}
                      height={400}
                      src="stone-cms/prod/adquira_bf_9cd1a51eb2.png"
                      layout="responsive"
                      className="object-contain"
                      alt="Produtos Stone - maquininha, cartão de crédito para empresas e pessoal e aplicativo com controle de vendas"
                    />
                  </div>

                  <div className={`hidden md:flex lg:hidden w-full`}>
                    <Image
                      width={672}
                      height={400}
                      src="stone-cms/prod/Tablet_dfd90f3f73.png"
                      layout="responsive"
                      className="object-contain"
                      alt="Produtos Stone - maquininha, cartão de crédito para empresas e pessoal e aplicativo com controle de vendas"
                    />
                  </div>
                </Choose.When>
                <Choose.Otherwise>
                  <Image
                    width={672}
                    height={400}
                    src="site-stone/banner/adquira"
                    layout="responsive"
                    className="object-contain"
                    alt="Produtos Stone - maquininha, cartão de crédito para empresas e pessoal e aplicativo com controle de vendas"
                  />
                </Choose.Otherwise>
              </Choose>
            </div>

            <div className="z-10 p-40 mt-[-1px] max-w-max text-white bg-display-900 rounded-br-[40px]">
              <p className="font-bold text-current paragraph-18">
                Com nosso time de vendas você vai:
              </p>
              <ul className="flex flex-col gap-12 mt-16">
                <li className="flex">
                  <PercentIcon />
                  <p className="ml-8 font-medium text-current">
                    Conhecer a sua taxa personalizada
                  </p>
                </li>
                <li className="flex">
                  <PosIcon />
                  <p className="ml-8 font-medium text-current">
                    Descobrir a solução ideal para você
                  </p>
                </li>
                <li className="flex">
                  <HelpCircleIcon />
                  <p className="ml-8 font-medium text-current">
                    Tirar todas as suas dúvidas
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <InbondFooter />
    </div>
  );
};
export default LayoutStone;
